module.exports = __webpack_public_path__ + "static/media/antiaging.d19ada98.svg";